export const EMAIL_OPT_IN_UI_COMPONENT_NAME = 'email_popup';
export const EMAIL_OPT_IN_MODAL_USER_CHOICE_UNDECIDED = -1;
export const EMAIL_OPT_IN_MODAL_USER_CHOICE_NO = 0;
export const EMAIL_OPT_IN_MODAL_USER_CHOICE_YES = 1;
